const getSessionValueByJSON = (key) => {
  try {
    return JSON.parse(sessionStorage[key]);
  } catch (error) {
    throw new Error(`Error fetching session !!! ${error}`);
  }
};

export { getSessionValueByJSON };
